<template>

    <div class="items-container">

        <div class="item" v-for="item in list">
            <div class="item-data" :class="{active:item.active}" @click="toggleItem(item)" :title="item.resource.name">
                <img class="production-tree-image" v-if="item.resource" :src="'https://d1fxy698ilbz6u.cloudfront.net/static/'+item.resource.image" alt="">
                <div>{{ (item.amount*level*24).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}/d</div>
                <div>@{{ parseFloat(item.price).toFixed(3) }}</div>
                <div>Lvl {{ ((item.amount*level)/item.resource.producedAnHour).toFixed(2) }}</div>
            </div>

            <div class="subitems" v-if="item.subitems">
                <div class="subitems-arrow">↓</div>
                <ProductionTree :list="item.subitems" :level="level"></ProductionTree>
            </div>

        </div>
    </div>
</template>

<script>


    export default {
        name: 'ProductionTree',
        props: {
            list: Object,
            level: Number
        },
        methods: {
            toggleItem(item){

                item.active = !item.active;
                if(item.subitems) {
                    this.setRecursiveActive(item, item.active)
                }

            },
            setRecursiveActive(item, active){
                let me = this;
                _.forEach(item.subitems, function(subitem) {
                        subitem.active = active;

                        if(subitem.subitems){
                            me.setRecursiveActive(subitem, active)
                        }
                })
            }
        }
    };
</script>

<style scoped lang="scss">

    .items-container {
        display: flex;
    }
img {
    max-height: 40px;
}
.item {
    display: inline-block;
    text-align: center;

}

    .production-tree-container .item:last-child {
        margin-right: 15px;
    }

.subitems {

    display: inline-block;
    text-align: left;
}
.subitems-arrow {
    padding-left: 35px;
}
    .item-data {
        width: 70px;
        height: 110px;
        font-size: 12px;
        margin: 5px;
        align-self: start;
        padding: 5px;
        cursor: pointer;
        background: #eee;
        transition: all 0.3s;

        &.active {
            background: #343a40;
            color: #fff;
        }


    }

</style>
